<template>
  <div>
    <v-row>
      <v-col cols="12" md="3" lg="3">
        <v-tooltip top v-if="anounc">
          <template v-slot:activator="{ on, attrs }">
            <v-card
              class="pa-3 rounded_max cursor"
              flat
              min-height="100px"
              v-bind="attrs"
              v-on="on"
              @click.native="updateAnounc(anounc)"
            >
              <div class="d-flex align-start mb-3">
                <v-icon class="mr-2">mdi-information-outline</v-icon>
                <h4>{{ anounc.title }}</h4>
              </div>
              <p class="default_txt text-justify">
                {{ anounc.description }}
              </p>
            </v-card>
          </template>
          <span>Click to edit</span>
        </v-tooltip>
        <div v-else>
          <v-skeleton-loader
            type="list-item-three-line"
            class="rounded_max mb-2"
          ></v-skeleton-loader>
        </div>
      </v-col>
      <v-col cols="12" md="9" lg="9">
        <div class="d-flex justify-space-between mb-4">
          <title-page title="Section List" />
          <v-btn
            :class="`cat_${course.course_categories_id} text-capitalize rounded-lg`"
            depressed
            dark
            @click="toCreate($route.params.idCourse)"
            v-if="
              role == 'SUPERADMIN' ||
              permissions.includes('LD') ||
              permissions.includes('TEACHER')
            "
          >
            <v-icon class="mr-1">mdi-bag-personal</v-icon>Add Section</v-btn
          >
        </div>
        <div v-if="!loading">
          <div v-if="dataSet.length">
            <draggable
              v-model="dataSet"
              class="list-group"
              @start.prevent="drag = true"
              @end="draged"
              v-bind="dragOptions"
              handle=".handle"
            >
              <transition-group
                type="transition"
                :name="!drag ? 'flip-list' : null"
              >
                <div
                  class="mb-4"
                  v-for="(item, i) in dataSet"
                  :key="`sect_${i}`"
                >
                  <v-card
                    class="rounded_max d-flex"
                    :elevation="item.status"
                    style="overflow: hidden"
                    @click.prevent="toDetail(item.id)"
                    :color="item.status ? '#fff' : '#fafafa'"
                  >
                    <div
                      class="strip"
                      :style="`background: ${
                        item.status == 0
                          ? '#EBEBE4'
                          : item.color
                          ? item.color
                          : '#f0ac91'
                      }`"
                    ></div>
                    <v-row no-gutters>
                      <v-col cols="8" md="10" lg="10">
                        <div class="pa-3">
                          <p class="mb-0">
                            <span class="font-weight-bold">{{
                              item.title
                            }}</span>
                            <span class="default_txt" v-if="item.status == 0">
                              (Inactive Section)</span
                            >
                          </p>
                          <p class="mb-0 mr-3 default_txt">
                            {{ item.modules.length }} modules
                          </p>
                        </div>
                      </v-col>
                      <v-col cols="4" md="2" lg="2"
                        ><div
                          class="pa-3 d-flex align-center justify-end bg-blue"
                          style="height: 100%"
                          v-if="!permissions.includes('GUEST')"
                        >
                          <v-btn icon style="cursor: move" class="handle">
                            <v-icon>mdi-drag </v-icon>
                          </v-btn>
                        </div></v-col
                      >
                    </v-row>
                  </v-card>
                </div>
              </transition-group>
            </draggable>
            <!-- last section -->
            <div class="mb-4" v-if="lastSection">
              <v-card
                class="rounded_max d-flex"
                elevation="1"
                style="overflow: hidden"
                @click.prevent="toDetail(lastSection.id)"
              >
                <div
                  class="strip"
                  :style="`background: ${
                    lastSection.color ? lastSection.color : '#f0ac91'
                  }`"
                ></div>
                <v-row no-gutters>
                  <v-col cols="10" md="11" lg="11">
                    <div class="pa-3">
                      <b> {{ lastSection.title }} </b>
                      <p class="ma-0 default_txt">
                        {{ lastSection.modules.length }} modules
                      </p>
                    </div>
                  </v-col>
                  <v-col cols="2" md="1" lg="1"
                    ><div class="pa-3 d-flex align-center" style="height: 100%">
                      <v-btn icon>
                        <v-icon>mdi-lastpass </v-icon>
                      </v-btn>
                    </div></v-col
                  >
                </v-row>
              </v-card>
            </div>
          </div>
          <div
            v-if="!dataSet.length"
            style="height: 300px"
            class="d-flex align-center justify-center flex-column"
          >
            <img
              src="../../../../assets/img/gundam/LMS Aset Illustrasi No Section.png"
              height="200px"
              alt=""
            />
            <b class="default_txt my-3">Add a section for your class</b>
            <p class="default_txt ma-0 text-center">
              Section can be more than once according to what you need
            </p>
          </div>
        </div>
        <div v-if="loading">
          <v-row no-gutters>
            <v-col cols="12" v-for="i in 3" :key="i">
              <div class="pb-3">
                <v-skeleton-loader
                  type="image"
                  class="rounded_max"
                  height="80px"
                ></v-skeleton-loader>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <div class="pa-3">
      <dialog-medium
        :d_create="d_create"
        @refetch="fetchSection"
        @close="d_create = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />

      <v-snackbar v-model="sorting" left :timeout="-1">
        {{ msg }}
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import draggable from "vuedraggable";
import TitlePage from "../../../../components/atom/titlePage.vue";
// import DialogMedium from "../../../dialog/dialogMedium.vue";
export default {
  components: {
    draggable,
    TitlePage,
    //  DialogMedium
  },
  props: ["course"],
  name: "listSection",
  mounted() {
    this.fetchSection();
  },
  // =>
  data() {
    return {
      loading: true,
      dataSet: [],
      lastSection: null,
      anounc: null,
      drag: false,
      sorted: [],
      sorting: false,
      msg: "",

      d_small: false,
      inventory: null,
      d_type: "",
      d_title: "",
      d_create: false,
    };
  },
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
    }),
  },
  //   =>
  computed: {
    ...mapState({
      role: (state) => state.role,
      permissions: (state) => state.permissions,
      banner: (state) => state.banner,
    }),
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  methods: {
    fetchSection() {
      this.loading = true;
      let data = {
        path: `manage/course/section/${this.$route.params.idCourse}?include=modules`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.loading = false;
          data.data.forEach((item) => {
            if (item.param_end == 1) {
              this.lastSection = item;
            } else if (item.param_end == 2) {
              this.anounc = item;
            } else {
              this.dataSet.push(item);
            }
          });
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    updateAnounc(item) {
      this.d_type = "u_anounc";
      this.d_title = "Anouncement";
      this.inventory = item;
      this.d_create = true;
    },
    toDetail(id) {
      this.$router.push(
        `/section/inclass/${id}/${this.$route.params.idCourse}`,
      );
    },
    toCreate(id) {
      this.$router.push(`/section/inclass/${id}/create`);
    },
    switchStatus(item) {
      this.d_type = "switch";
      item["module"] = "course/section";
      this.d_title = "";
      this.inventory = item;
      this.d_small = true;
    },
    draged() {
      this.drag = false;
      this.dataSet.forEach((el, idx) => {
        let obj = {
          id: el.id,
          weight: idx + 1,
        };
        this.sorted.push(obj);
      });
      this.switchOrder();
    },
    switchOrder() {
      this.msg = "moving section...";
      this.sorting = true;
      let body = {
        course_id: this.$route.params.idCourse,
        data_course: this.sorted,
      };
      let data = {
        path: `manage/course/section/weight/switch`,
        body: body,
      };
      this.$store
        .dispatch("course/postApi", data)
        .then((data) => {
          this.msg = "Section moved";
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          setTimeout(() => {
            this.sorting = false;
          }, 800);
        })
        .catch((err) => {
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
          this.msg = "Error";
          setTimeout(() => {
            this.sorting = false;
          }, 800);
        });
    },
  },
};
</script>

<style scoped>
.strip {
  padding: 3px;
  width: 10px;
  max-height: 100%;
  border-radius: 0 !important;
}
</style>
